import { service, BASE_API } from '@/utils/request'
// const service = service_3
const v2 = BASE_API
const staticUrl = process.env.BASE_STATIC

export default {
	getList(data) {
		return service ({
		  url: '/cloud/camp/admin/group/search',
		  method: 'post',
		  data
		})
	},
	addData(data) {
		return service ({
		  url: '/cloud/camp/admin/group',
		  method: 'post',
		  data: data
		})
	},
	getPeriod(data) {
		return service ({
		  url: '/cloud/camp/admin/group/getPeriods',
		  method: 'post',
		  data
		})
	},
	getDetail(path) {
		return service ({
		  url: '/cloud/camp/admin/group/' + path,
		  method: 'get'
		})
	},
	editData(path, data) {
		return service ({
		  url: '/cloud/camp/admin/group/' + path,
		  method: 'put',
		  data
		})
	},
	getBind(groupId, type) {
		return service ({
		  url: '/cloud/camp/admin/course/search/' + groupId + '/' + type,
		  method: 'get'
		})
	},
	bind(groupId, type, data) {
		return service ({
			url: '/cloud/camp/admin/course/' + groupId + '/' + type,
			method: 'post',
			data
		})
	},
	delBind(groupId, courseId) {
		return service ({
			url: '/cloud/camp/admin/course/' + groupId + '/' + courseId,
			method: 'delete'
		})
	},
	getStudents(data) {
		return service ({
			url: '/cloud/camp/admin/group-user/search',
			method: 'post',
			data
		})
	},
	// 启用禁用
	forbid(id, status) {
		return service ({
			url: `/cloud/camp/admin/group/prohibit/${id}/${status}`,
			method: 'put'
		})
	},
	// 禁言
	mute(id, chatStatus) {
		return service ({
			url: `/cloud/camp/admin/group-user/memberVoiceLimit/${id}/${chatStatus}`,
			method: 'put'
		})
	},
	// 踢出
	kick(id) {
		return service ({
			url: `/cloud/camp/admin/group-user/removeMember/${id}`,
			method: 'put'
		})
	},
	exportExcel(path) {
		return service({
			url: '/cloud/camp/admin/group-user/exportMember/' + path,
			method: 'post',
			responseType: 'blob'
		})
	},
	// 导入学员
	excelUpload: v2 + `/cloud/camp/admin/group-user/importMember/`,
	// 批量导入学员
	excelBatchUpload: v2 + `/cloud/camp/admin/group-user/importMemberList/`,

  // 检查导入学员
	checkExcelUpload: v2 + `/cloud/camp/admin/group-user/checkImportMember/`,
  // 检查批量导入学员
	checkExcelBatchUpload: v2 + `/cloud/camp/admin/group-user/checkImportMemberList/`,

	// 下载模板
	down: 'https://file.ibabygroup.cn/CampImportTemplate0240.xlsx',
	// 私房课
	// 获取课程分类
	getTypeList(params) {
	    return service({
			url: '/cloud/course/v1/admin/course/product/type/list',
			method: 'get',
			params: params
		})
	},
	listByCamp(id) {
		return service ({
			url: `/cloud/course/v1/admin/privateCourseChapter/listByCamp/${id}`,
			method: 'get'
		})
	},
	// 添加私房课章节
	privateCourseChapter(id, data) {
		return service ({
			url: `/cloud/course/v1/admin/privateCourseChapter/${id}`,
			method: 'post',
			data
		})
	},
	// 删除私房课章节
	privateCourseChapter_delete(id) {
		return service ({
			url: `/cloud/course/v1/admin/privateCourseChapter/${id}`,
			method: 'delete'
		})
	},
	// 上移私房课章节
	privateCourseChapter_up(id) {
		return service ({
			url: `/cloud/course/v1/admin/privateCourseChapter/up/${id}`,
			method: 'put'
		})
	},
	// 下移私房课章节
	privateCourseChapter_down(id) {
		return service ({
			url: `/cloud/course/v1/admin/privateCourseChapter/down/${id}`,
			method: 'put'
		})
	},
	// 更新章节
	privateCourseChapter_update(id, data) {
		return service ({
			url: `/cloud/course/v1/admin/privateCourseChapter/${id}`,
			method: 'put',
			data
		})
	},
	// 删除课程
	privateCourse_remove(id) {
		return service ({
			url: `/cloud/course/v1/admin/privateCourse/remove/${id}`,
			method: 'post'
		})
	},
	// 添加课程
	addByChapter(id, data) {
		return service ({
			url: `/cloud/course/v1/admin/privateCourse/addByChapter/${id}`,
			method: 'post',
			data
		})
	},
	// 更新课程
	privateCourse_update(id, data) {
		return service ({
			url: `/cloud/course/v1/admin/privateCourse/update/${id}`,
			method: 'put',
			data
		})
	},
	/** 群直播 */
	liveList(id) {
		return service ({
			url: `/cloud/course/v1/admin/campGroupLive/listByCamp/${id}`,
			method: 'get'
		})
	},
	addByCamp(id, data) {
		return service ({
			url: `/cloud/course/v1/admin/campGroupLive/addByCamp/${id}`,
			method: 'post',
			data
		})
	},
	// 删除课程源绑定
	deleteCourseSource(id) {
		return service ({
			url: `/cloud/course/v1/admin/campGroupLive/${id}`,
			method: 'delete'
		})
	},
	/** 把手广告 */
	handleAdvert(id) {
		return service ({
			url: `/cloud/camp/admin/handleAdvert/${id}`,
			method: 'get'
		})
	},
	handleAdvert_update(id, data) {
		return service ({
			url: `/cloud/camp/admin/handleAdvert/${id}`,
			method: 'put',
			data
		})
	},
	/** 图文 */
	imageTextMessage(id, data) {
		return service ({
			url: `/cloud/camp/admin/imageTextMessage/searchByCamp/${id}`,
			method: 'post',
			data
		})
	},
	imageTextMessage_update(id, data) {
		return service ({
			url: `/cloud/camp/admin/imageTextMessage/${id}`,
			method: 'put',
			data
		})
	},
	imageTextMessage_remove(id) {
		return service ({
			url: `/cloud/camp/admin/imageTextMessage/${id}`,
			method: 'delete'
		})
	},
	dissolve(id) {
		return service ({
			url: `/cloud/camp/admin/group/${id}`,
			method: 'delete'
		})
	},
	updateRenewUrl(data) {
		return service({
			url: `/cloud/camp/admin/group/url/${data.id}`,
			method: 'put',
			data: data.url
		})
	}
}



// WEBPACK FOOTER //
// ./src/api/operateManage/campmanage.js